import React, { useState, useEffect } from 'react';

import api from '../../services/api';

import Header from '../../components/Header';
import Input from '../../components/Input';
import ListQuestions from './components/ListQuestions';
import Footer from '../../components/Footer';

import searchIcon from '../../assets/icons/search2.png';

import {
  Container,
  GradientBackground,
  Title,
  Content,
  SearchContainer,
  Spinner,
} from './styles';
import Logo from './components/Logo';
import background from '../../assets/img/background.png';

const FrequentlyAskedQuestions = () => {
  const [search, setSearch] = useState('');
  const [itensSearch, setItensSearch] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchQuestions = async () => {
    setLoading(true);
    await api
      .get('/common-questions')
      .then((response) => {
        setData(response.data);
        setLoading(false);
      })
      .catch((error) => setLoading(false));
  };

  const formatString = (value) => {
    let newValue = value.toUpperCase();
    newValue = newValue.replace(/[ÀÁÂÃÄÅ]/, 'A');
    newValue = newValue.replace(/[ÈÉÊË]/, 'E');
    newValue = newValue.replace(/[ÌÍÎÏ]/, 'I');
    newValue = newValue.replace(/[ÒÓÕÔÖ]/, 'O');
    newValue = newValue.replace(/[ÙÚÛÜ]/, 'U');
    newValue = newValue.replace(/[Ç]/, 'C');
    return newValue;
  };

  const handleSearch = (value) => {
    setSearch(value);

    let questionsFound = [];
    for (let item of data) {
      const question = formatString(item.question);
      const answer = formatString(item.answer);
      const valueUpperCase = formatString(value);
      if (
        question.indexOf(valueUpperCase) >= 0 ||
        answer.indexOf(valueUpperCase) >= 0
      ) {
        questionsFound.push(item);
      }
    }

    setItensSearch(questionsFound);
  };

  const renderQuestions = () => {
    if (loading) {
      return <Spinner />;
    }

    if (search !== '') {
      return <ListQuestions data={itensSearch} />;
    }
    return <ListQuestions data={data} />;
  };

  useEffect(() => {
    fetchQuestions();
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container style={{ backgroundImage: `url(${background})`, backgroundSize: 'cover' }}>
      <Header />
      <Logo />
      <Content>
        <SearchContainer>
          <Input
            placeholder="Qual é a sua dúvida?"
            iconRight={searchIcon}
            value={search}
            onInput={(event) => handleSearch(event.target.value)}
          />
        </SearchContainer>
        {renderQuestions()}
      </Content>
      <Footer />
    </Container>
  );
};

export default FrequentlyAskedQuestions;
